import { render, staticRenderFns } from "./DataXueTang.vue?vue&type=template&id=22b1b8a2&"
import script from "./DataXueTang.vue?vue&type=script&lang=js&"
export * from "./DataXueTang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports